// SAD-1337 (REG-67) deviations from Registries.dc.html, kept on purpose:
// - Gov Orgs keeps its Add/Edit actions (REG-09 keeps them; the mockup has none).
// - Rate Book keeps its "Burden" column (REG-26/REG-42 period and burden decisions).
// - Status columns on Capabilities, Vehicles and LCAT are kept.
// - Contacts keeps its "Role" and "Account" columns.
// - Vehicle "Price lists on file" sub-line: "{n} companies we track" wins, falling
//   back to "{n} holders" only when no tracked company has pricing.
// - Rate Book relation filter is disabled until a labor category (anchor) is picked: the
//   backend only applies relation_in to anchored reads. "Relation: any" sends all three
//   mapping types the backend accepts (EQUIVALENT, NARROWER, BROADER).
// - Rate Book "Upload Pricing Sheet" is offered only to holders of the upload gate.
// - Program Roles "Used on" counts distinct registry contracts linked (govcon.program_opportunity_links)
//   to programs whose active roster uses the role; programs have no direct registry-contract FK.
//   It shows "—" when the contract count is unavailable.
// - LCAT Review queue links to /registries/review-queue?kind=LCAT_CANDIDATE (the route rejects
//   kind=LCAT) and Compare to /registries/labor-categories/{anchorId}, both only with
//   registries_records_v1 on; otherwise they stay in-page (Compare's anchor picker is the old
//   REG-19 view, kept as the picker). Review queue (n) is the PENDING candidate count, the same
//   population the queue lists. The Mappings sub-tab no longer carries a pending count.
// - "Vehicle mismatch (n)" counts the tenant's unretracted DAT-13 lcat_mismatch rfi_signals,
//   read via a new field on ListLaborCategoryEntriesResponse (ryugu is the browser's Connect
//   handler for this tab, not zou).
export const REGISTRY_TABS = [
    {
        key: 'contracts',
        label: 'Contracts'
    },
    {
        key: 'companies',
        label: 'Companies'
    },
    {
        key: 'contacts',
        label: 'Contacts'
    },
    {
        key: 'govorgs',
        label: 'Government Orgs'
    },
    {
        key: 'capabilities',
        label: 'Capabilities'
    },
    {
        key: 'vehicles',
        label: 'Contract Vehicles'
    },
    {
        key: 'lcats',
        label: 'Labor Categories'
    },
    {
        key: 'rate-book',
        label: 'Rate Book'
    },
    {
        key: 'roles',
        label: 'Program Roles'
    },
    {
        key: 'pricing-sheets',
        label: 'Pricing Sheets'
    }
];
export const isRegistryTabKey = (s)=>REGISTRY_TABS.some((tab)=>tab.key === s);
export const registryTabLabel = (key)=>REGISTRY_TABS.find((tab)=>tab.key === key)?.label ?? key;
